/**
 * Registers the PackedScene ExtResource an instance ref names, then loads the
 * scene. The viewport's instanced node and the outliner's sub-scene rows share it.
 */
import { useEffect } from 'react';
import { useResource, useResourceLoader } from '../../resources/useResource.js';
import { findExtResource, parseResourceReference } from '../../resources/SubResourceResolver.js';
/**
 * A null `loadPath` registers and loads nothing, and the result stays `pending`.
 * The caller resolves it from `instanceRef`, and nulls it for a scene it refuses.
 */
export function useInstancedScene(instanceRef, externalResources, loadPath) {
    const loader = useResourceLoader();
    // Ahead of `useResource`, since a component runs its effects in order and the
    // load checks the registered type. Idempotent.
    useEffect(() => {
        if (!loader || !loadPath)
            return;
        const parsed = parseResourceReference(instanceRef);
        if (parsed?.type !== 'ExtResource')
            return;
        const ext = findExtResource(externalResources, parsed.id);
        if (ext)
            loader.register(ext);
    }, [loader, loadPath, instanceRef, externalResources]);
    // `useResource` requests nothing for '', so the hook count stays stable.
    return useResource(loadPath ?? '', 'scene');
}
//# sourceMappingURL=useInstancedScene.js.map